import { createSignal } from "solid-js";

// Whether an inactivity lock screen is on the page, for the layers painted above it (the toast
// stack) that have to stand down while it is. Module scope because the lock screen and the toast
// stack mount in different component trees, and on Hotwire pages in different Solid roots.
//
// A count rather than a flag: nothing stops a page mounting two lock screens (a Hotwire layout's
// and an embedded Inertia layout's), and one going away must not uncover what the other hides.
const [lockScreens, setLockScreens] = createSignal(0);

export const lockScreenUp = () => lockScreens() > 0;

/** Marks one lock screen as showing. Returns its release, for the caller's cleanup. */
export function holdLockScreen(): () => void {
  setLockScreens((count) => count + 1);
  return () => setLockScreens((count) => count - 1);
}
